import { render } from "./QuotePage.vue?vue&type=template&id=476a06ff&scoped=true"
import script from "./QuotePage.vue?vue&type=script&lang=js"
export * from "./QuotePage.vue?vue&type=script&lang=js"

import "./QuotePage.vue?vue&type=style&index=0&id=476a06ff&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-476a06ff"]])

export default __exports__